module.exports = require("npm:owl.carousel@2.2.0/dist/owl.carousel.js");